import Input from 'components/common/form/input/Input';
import { Form, Formik } from 'formik';
import React from 'react';
import { Col, FormGroup, FormLabel, Row } from 'react-bootstrap';
import { genderOptions } from './config';
import Select from 'components/common/form/select/Select';
import * as Yup from 'yup';
import { BasicFormValues, Props } from './studentBasic.type';
import { transformInputDate } from 'helpers/utils';

const validationSchema = Yup.object({
  username: Yup.string()
    .required('Username is required')
    .min(3, 'Username must be at least 3 characters')
    .max(20, 'Username cannot exceed 20 characters'),

  registerNumber: Yup.string()
    .required('Register Number is required')
    .matches(/^[a-zA-Z0-9]+$/, 'Register Number must be alphanumeric'),
  gender: Yup.string()
    .required('Gender is required')
    .oneOf(
      ['male', 'female', 'other'],
      'Gender must be Male, Female, or Other'
    ),

  email: Yup.string()
    .required('Email is required')
    .email('Enter a valid email address'),

  contactNumber: Yup.string()
    .required('Contact Number is required')
    .matches(/^[0-9]+$/, 'Contact Number must be numeric')
    .min(10, 'Contact Number must be at least 10 digits')
    .max(15, 'Contact Number cannot exceed 15 digits'),

  dateOfBirth: Yup.date()
    .required('Date of Birth is required')
    .max(new Date(), 'Date of Birth cannot be in the future')
});

function StudentBasicForm({ innerRef, data, isReadOnly }: Props) {
  const handleSubmit = (values: BasicFormValues) => {
    return Promise.resolve(values);
  };
  return (
    <Formik
      innerRef={innerRef}
      initialValues={{
        username: data?.username ?? '',
        registerNumber: data?.info?.registerNumber ?? '',
        gender: data?.info?.gender ?? '',
        email: data?.email ?? '',
        contactNumber: data?.info?.contactNumber ?? '',
        dateOfBirth: data?.info?.dateOfBirth
          ? transformInputDate(data.info.dateOfBirth)
          : ''
      }}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      <Form>
        <Row className="g-5">
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="registerNumber">Register Number</FormLabel>
              <Input
                name="registerNumber"
                id="registerNumber"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="username">Name</FormLabel>
              <Input
                name="username"
                id="username"
                placeholder="Ex: John"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="gender">Gender</FormLabel>
              <Select
                name="gender"
                id="gender"
                options={genderOptions}
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={8}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="email">Email Address</FormLabel>
              <Input
                name="email"
                id="email"
                placeholder="Ex: john@gmail.com"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="contactNumber">Contact Number</FormLabel>
              <Input
                name="contactNumber"
                id="contactNumber"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
          <Col xs={12} xl={4}>
            <FormGroup className="text-start">
              <FormLabel htmlFor="dateOfBirth">Date of birth</FormLabel>
              <Input
                name="dateOfBirth"
                id="dateOfBirth"
                type="date"
                disabled={isReadOnly}
              />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Formik>
  );
}

export default StudentBasicForm;
